import { render, staticRenderFns } from "./pink-spot.vue?vue&type=template&id=f673d53c&"
import script from "./pink-spot.vue?vue&type=script&lang=js&"
export * from "./pink-spot.vue?vue&type=script&lang=js&"
import style0 from "./pink-spot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports